document.addEventListener('DOMContentLoaded', function() {
    const storedProductHandles = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];
    const recentlyViewedSection = document.getElementById('recently-viewed-products');
    
    if (storedProductHandles.length > 0) {
        const url = `/pages/contact?view=recently-view&product_list=${storedProductHandles.join(',')}`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data;

                const listItems = tempDiv.querySelectorAll('.recently-view-list'); // Adjust based on your returned HTML
                const productList = recentlyViewedSection.querySelector('ul');

                // Clear existing items
                productList.innerHTML = '';

                // Append each item to the product list
                listItems.forEach(item => {
                    if (item.getAttribute('var-id')) { // Check if the item has a 'var-id' attribute
                        productList.appendChild(item);
                    }
                });

                // Show the recently viewed products section if there are items
                recentlyViewedSection.style.display = productList.children.length > 0 ? 'block' : 'none';
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    } else {
        recentlyViewedSection.style.display = 'none';
    }
});